import { render, staticRenderFns } from "./EmbeddedDashboard.vue?vue&type=template&id=9ca6b92c&scoped=true&"
import script from "./EmbeddedDashboard.vue?vue&type=script&lang=js&"
export * from "./EmbeddedDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca6b92c",
  null
  
)

export default component.exports